const CLOUDINARY_UPLOAD_SEGMENT = "/upload/";
const CLOUDINARY_AUTO_TRANSFORM = "f_auto,q_auto";

export function withCloudinaryAutoFormat(url: string): string {
  if (!url.includes("res.cloudinary.com") || !url.includes(CLOUDINARY_UPLOAD_SEGMENT)) {
    return url;
  }

  if (url.includes(CLOUDINARY_AUTO_TRANSFORM)) {
    return url;
  }

  return url.replace(
    CLOUDINARY_UPLOAD_SEGMENT,
    `${CLOUDINARY_UPLOAD_SEGMENT}${CLOUDINARY_AUTO_TRANSFORM}/`,
  );
}
